export const cityPaths = [
  {
    id: "1600000US3651000",
  },
  {
    id: "1600000US0644000",
  },
  {
    id: "1600000US1714000",
  },
  {
    id: "1600000US4835000",
  },
  {
    id: "1600000US4260000",
  },
  {
    id: "1600000US0455000",
  },
  {
    id: "1600000US4865000",
  },
  {
    id: "1600000US0666000",
  },
  {
    id: "1600000US4819000",
  },
  {
    id: "1600000US0668000",
  },
  {
    id: "1600000US4805000",
  },
  {
    id: "1600000US1836003",
  },
  {
    id: "1600000US1235000",
  },
  {
    id: "1600000US0667000",
  },
  {
    id: "1600000US3918000",
  },
  {
    id: "1600000US3712000",
  },
  {
    id: "1600000US4827000",
  },
  {
    id: "1600000US2622000",
  },
  {
    id: "1600000US4824000",
  },
  {
    id: "1600000US4748000",
  },
  {
    id: "1600000US5363000",
  },
  {
    id: "1600000US0820000",
  },
  {
    id: "1600000US1150000",
  },
  {
    id: "1600000US2507000",
  },
  {
    id: "1600000US4752006",
  },
  {
    id: "1600000US2404000",
  },
  {
    id: "1600000US4055000",
  },
  {
    id: "1600000US2148006",
  },
  {
    id: "1600000US4159000",
  },
  {
    id: "1600000US3240000",
  },
  {
    id: "1600000US5553000",
  },
  {
    id: "1600000US3502000",
  },
  {
    id: "1600000US0477000",
  },
  {
    id: "1600000US0627000",
  },
  {
    id: "1600000US0664000",
  },
  {
    id: "1600000US0643000",
  },
  {
    id: "1600000US2938000",
  },
  {
    id: "1600000US0446000",
  },
  {
    id: "1600000US5182000",
  },
  {
    id: "1600000US1304000",
  },
  {
    id: "1600000US0816000",
  },
  {
    id: "1600000US3137000",
  },
  {
    id: "1600000US3755000",
  },
  {
    id: "1600000US1245000",
  },
  {
    id: "1600000US0653000",
  },
  {
    id: "1600000US2743000",
  },
  {
    id: "1600000US4075000",
  },
  {
    id: "1600000US3916000",
  },
  {
    id: "1600000US2079000",
  },
  {
    id: "1600000US4804000",
  },
  {
    id: "1600000US2255000",
  },
  {
    id: "1600000US0603526",
  },
  {
    id: "1600000US1271000",
  },
  {
    id: "1600000US1571550",
  },
  {
    id: "1600000US0804000",
  },
  {
    id: "1600000US0602000",
  },
  {
    id: "1600000US0669000",
  },
  {
    id: "1600000US2965000",
  },
  {
    id: "1600000US0662000",
  },
  {
    id: "1600000US4817000",
  },
  {
    id: "1600000US2146027",
  },
  {
    id: "1600000US4261000",
  },
  {
    id: "1600000US0203000",
  },
  {
    id: "1600000US0675000",
  },
  {
    id: "1600000US3915000",
  },
  {
    id: "1600000US2758000",
  },
  {
    id: "1600000US3977000",
  },
  {
    id: "1600000US3728000",
  },
  {
    id: "1600000US3451000",
  },
  {
    id: "1600000US4858016",
  },
  {
    id: "1600000US3231900",
  },
  {
    id: "1600000US3128000",
  },
  {
    id: "1600000US3611000",
  },
  {
    id: "1600000US3436000",
  },
  {
    id: "1600000US0613392",
  },
  {
    id: "1600000US1825000",
  },
  {
    id: "1600000US1253000",
  },
  {
    id: "1600000US1263000",
  },
  {
    id: "1600000US0412000",
  },
  {
    id: "1600000US4841473",
  },
  {
    id: "1600000US5157000",
  },
  {
    id: "1600000US3719000",
  },
  {
    id: "1600000US5548000",
  },
  {
    id: "1600000US4845000",
  },
  {
    id: "1600000US0636770",
  },
  {
    id: "1600000US3775000",
  },
  {
    id: "1600000US0427820",
  },
  {
    id: "1600000US4829000",
  },
  {
    id: "1600000US1230025",
  },
  {
    id: "1600000US3260600",
  },
  {
    id: "1600000US5116000",
  },
  {
    id: "1600000US0427400",
  },
  {
    id: "1600000US2205000",
  },
  {
    id: "1600000US4837000",
  },
  {
    id: "1600000US0465000",
  },
  {
    id: "1600000US3251800",
  },
  {
    id: "1600000US0626000",
  },
  {
    id: "1600000US1608830",
  },
  {
    id: "1600000US5167000",
  },
  {
    id: "1600000US0665000",
  },
];

export const cityRef = {
  "new-york-city-ny": {
    description:
      "New York city, New York is a city, town, place equivalent, and township located in New York. New York city, New York has a land area of 300.3 square miles.",
    subtitle: "Place in New York",
    lat: 40.7127837,
    lon: -74.0059413,
    title: "New York City, NY",
    key: "1600000US3651000",
  },
  "los-angeles-ca": {
    description:
      "Los Angeles city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 34.0522342,
    lon: -118.2436849,
    title: "Los Angeles, CA",
    key: "1600000US0644000",
  },
  "chicago-il": {
    description:
      "Chicago city, Illinois is a city, town, place equivalent, and township located in Illinois. Chicago city, Illinois has a land area of 227.3 square miles.",
    subtitle: "Place in Illinois",
    lat: 41.8781136,
    lon: -87.6297982,
    title: "Chicago, IL",
    key: "1600000US1714000",
  },
  "houston-tx": {
    description:
      "Houston city, Texas is a city, town, place equivalent, and township located in Texas. Houston city, Texas has a land area of 640.0 square miles.",
    subtitle: "Place in Texas",
    lat: 29.7604267,
    lon: -95.3698028,
    title: "Houston, TX",
    key: "1600000US4835000",
  },
  "philadelphia-pa": {
    description:
      "Philadelphia city, Pennsylvania is a city, town, place equivalent, and township located in Pennsylvania. Philadelphia city, Pennsylvania has a land area of 134.2 square miles.",
    subtitle: "Place in Pennsylvania",
    lat: 39.9525839,
    lon: -75.1652215,
    title: "Philadelphia, PA",
    key: "1600000US4260000",
  },
  "phoenix-az": {
    description:
      "Phoenix city, Arizona is a city, town, place equivalent, and township located in Arizona. Phoenix city, Arizona has a land area of 517.5 square miles.",
    subtitle: "Place in Arizona",
    lat: 33.4483771,
    lon: -112.0740373,
    title: "Phoenix, AZ",
    key: "1600000US0455000",
  },
  "san-antonio-tx": {
    description:
      "San Antonio city, Texas is a city, town, place equivalent, and township located in Texas.",
    subtitle: "Place in Texas",
    lat: 29.4241219,
    lon: -98.4936282,
    title: "San Antonio, TX",
    key: "1600000US4865000",
  },
  "san-diego-ca": {
    description:
      "San Diego city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 32.715738,
    lon: -117.1610838,
    title: "San Diego, CA",
    key: "1600000US0666000",
  },
  "dallas-tx": {
    description:
      "Dallas city, Texas is a city, town, place equivalent, and township located in Texas. Dallas city, Texas has a land area of 339.6 square miles.",
    subtitle: "Place in Texas",
    lat: 32.7766642,
    lon: -96.7969879,
    title: "Dallas, TX",
    key: "1600000US4819000",
  },
  "san-jose-ca": {
    description:
      "San Jose city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 37.3382082,
    lon: -121.8863286,
    title: "San Jose, CA",
    key: "1600000US0668000",
  },
  "austin-tx": {
    description:
      "Austin city, Texas is a city, town, place equivalent, and township located in Texas.",
    subtitle: "Place in Texas",
    lat: 30.267153,
    lon: -97.7430608,
    title: "Austin, TX",
    key: "1600000US4805000",
  },
  "indianapolis-in": {
    description:
      "Indianapolis city (balance), Indiana is a city, town, place equivalent, and township located in Indiana. Indianapolis city (balance), Indiana has a land area of 361.5 square miles.",
    subtitle: "Place in Indiana",
    lat: 39.768403,
    lon: -86.158068,
    title: "Indianapolis, IN",
    key: "1600000US1836003",
  },
  "jacksonville-fl": {
    description:
      "Jacksonville city, Florida is a city, town, place equivalent, and township located in Florida. Jacksonville city, Florida has a land area of 747.3 square miles.",
    subtitle: "Place in Florida",
    lat: 30.3321838,
    lon: -81.655651,
    title: "Jacksonville, FL",
    key: "1600000US1235000",
  },
  "san-francisco-ca": {
    description:
      "San Francisco city, California is a city, town, place equivalent, and township located in California. San Francisco city, California has a land area of 46.9 square miles.",
    subtitle: "Place in California",
    lat: 37.7749295,
    lon: -122.4194155,
    title: "San Francisco, CA",
    key: "1600000US0667000",
  },
  "columbus-oh": {
    description:
      "Columbus city, Ohio is a city, town, place equivalent, and township located in Ohio. Columbus city, Ohio has a land area of 219.1 square miles.",
    subtitle: "Place in Ohio",
    lat: 39.9611755,
    lon: -82.9987942,
    title: "Columbus, OH",
    key: "1600000US3918000",
  },
  "charlotte-nc": {
    description:
      "Charlotte city, North Carolina is a city, town, place equivalent, and township located in North Carolina. Charlotte city, North Carolina has a land area of 307.2 square miles.",
    subtitle: "Place in North Carolina",
    lat: 35.2270869,
    lon: -80.8431267,
    title: "Charlotte, NC",
    key: "1600000US3712000",
  },
  "fort-worth-tx": {
    description:
      "Fort Worth city, Texas is a city, town, place equivalent, and township located in Texas. Fort Worth city, Texas has a land area of 345.5 square miles.",
    subtitle: "Place in Texas",
    lat: 32.7554883,
    lon: -97.3307658,
    title: "Fort Worth, TX",
    key: "1600000US4827000",
  },
  "detroit-mi": {
    description:
      "Detroit city, Michigan is a city, town, place equivalent, and township located in Michigan. Detroit city, Michigan has a land area of 138.7 square miles.",
    subtitle: "Place in Michigan",
    lat: 42.331427,
    lon: -83.0457538,
    title: "Detroit, MI",
    key: "1600000US2622000",
  },
  "el-paso-tx": {
    description:
      "El Paso city, Texas is a city, town, place equivalent, and township located in Texas. El Paso city, Texas has a land area of 257.4 square miles.",
    subtitle: "Place in Texas",
    lat: 31.7775757,
    lon: -106.4424559,
    title: "El Paso, TX",
    key: "1600000US4824000",
  },
  "memphis-tn": {
    description:
      "Memphis city, Tennessee is a city, town, place equivalent, and township located in Tennessee. Memphis city, Tennessee has a land area of 317.3 square miles.",
    subtitle: "Place in Tennessee",
    lat: 35.1495343,
    lon: -90.0489801,
    title: "Memphis, TN",
    key: "1600000US4748000",
  },
  "seattle-wa": {
    description:
      "Seattle city, Washington is a city, town, place equivalent, and township located in Washington. Seattle city, Washington has a land area of 83.8 square miles.",
    subtitle: "Place in Washington",
    lat: 47.6062095,
    lon: -122.3320708,
    title: "Seattle, WA",
    key: "1600000US5363000",
  },
  "denver-co": {
    description:
      "Denver city, Colorado is a city, town, place equivalent, and township located in Colorado. Denver city, Colorado has a land area of 153.3 square miles.",
    subtitle: "Place in Colorado",
    lat: 39.7392358,
    lon: -104.990251,
    title: "Denver, CO",
    key: "1600000US0820000",
  },
  "washington-d.c.-dc": {
    description:
      "Washington city, District of Columbia is a city, town, place equivalent, and township located in District of Columbia. Washington city, District of Columbia has a land area of 61.1 square miles.",
    subtitle: "Place in District of Columbia",
    lat: 38.9071923,
    lon: -77.0368707,
    title: "Washington, D.C., DC",
    key: "1600000US1150000",
  },
  "boston-ma": {
    description:
      "Boston city, Massachusetts is a city, town, place equivalent, and township located in Massachusetts. Boston city, Massachusetts has a land area of 48.3 square miles.",
    subtitle: "Place in Massachusetts",
    lat: 42.3600825,
    lon: -71.0588801,
    title: "Boston, MA",
    key: "1600000US2507000",
  },
  "nashville-tn": {
    description:
      "Nashville-Davidson metropolitan government (balance), Tennessee is a city, town, place equivalent, and township located in Tennessee.",
    subtitle: "Place in Tennessee",
    lat: 36.1626638,
    lon: -86.7816016,
    title: "Nashville, TN",
    key: "1600000US4752006",
  },
  "baltimore-md": {
    description:
      "Baltimore city, Maryland is a city, town, place equivalent, and township located in Maryland. Baltimore city, Maryland has a land area of 80.9 square miles.",
    subtitle: "Place in Maryland",
    lat: 39.2903848,
    lon: -76.6121893,
    title: "Baltimore, MD",
    key: "1600000US2404000",
  },
  "oklahoma-city-ok": {
    description:
      "Oklahoma City city, Oklahoma is a city, town, place equivalent, and township located in Oklahoma. Oklahoma City city, Oklahoma has a land area of 606.3 square miles.",
    subtitle: "Place in Oklahoma",
    lat: 35.4675602,
    lon: -97.5164276,
    title: "Oklahoma City, OK",
    key: "1600000US4055000",
  },
  "louisville-ky": {
    description:
      "Louisville/Jefferson County metro government (balance), Kentucky is a city, town, place equivalent, and township located in Kentucky.",
    subtitle: "Place in Kentucky",
    lat: 38.2526647,
    lon: -85.7584557,
    title: "Louisville, KY",
    key: "1600000US2148006",
  },
  "portland-or": {
    description:
      "Portland city, Oregon is a city, town, place equivalent, and township located in Oregon. Portland city, Oregon has a land area of 133.4 square miles.",
    subtitle: "Place in Oregon",
    lat: 45.5230622,
    lon: -122.6764816,
    title: "Portland, OR",
    key: "1600000US4159000",
  },
  "las-vegas-nv": {
    description:
      "Las Vegas city, Nevada is a city, town, place equivalent, and township located in Nevada. Las Vegas city, Nevada has a land area of 141.7 square miles.",
    subtitle: "Place in Nevada",
    lat: 36.1699412,
    lon: -115.1398296,
    title: "Las Vegas, NV",
    key: "1600000US3240000",
  },
  "milwaukee-wi": {
    description:
      "Milwaukee city, Wisconsin is a city, town, place equivalent, and township located in Wisconsin. Milwaukee city, Wisconsin has a land area of 96.2 square miles.",
    subtitle: "Place in Wisconsin",
    lat: 43.0389025,
    lon: -87.9064736,
    title: "Milwaukee, WI",
    key: "1600000US5553000",
  },
  "albuquerque-nm": {
    description:
      "Albuquerque city, New Mexico is a city, town, place equivalent, and township located in New Mexico. Albuquerque city, New Mexico has a land area of 187.2 square miles.",
    subtitle: "Place in New Mexico",
    lat: 35.0853336,
    lon: -106.6055534,
    title: "Albuquerque, NM",
    key: "1600000US3502000",
  },
  "tucson-az": {
    description:
      "Tucson city, Arizona is a city, town, place equivalent, and township located in Arizona. Tucson city, Arizona has a land area of 238.0 square miles.",
    subtitle: "Place in Arizona",
    lat: 32.2217429,
    lon: -110.926479,
    title: "Tucson, AZ",
    key: "1600000US0477000",
  },
  "fresno-ca": {
    description:
      "Fresno city, California is a city, town, place equivalent, and township located in California. Fresno city, California has a land area of 114.7 square miles.",
    subtitle: "Place in California",
    lat: 36.7468422,
    lon: -119.7725868,
    title: "Fresno, CA",
    key: "1600000US0627000",
  },
  "sacramento-ca": {
    description:
      "Sacramento city, California is a city, town, place equivalent, and township located in California. Sacramento city, California has a land area of 97.7 square miles.",
    subtitle: "Place in California",
    lat: 38.5815719,
    lon: -121.4943996,
    title: "Sacramento, CA",
    key: "1600000US0664000",
  },
  "long-beach-ca": {
    description:
      "Long Beach city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 33.7700504,
    lon: -118.1937395,
    title: "Long Beach, CA",
    key: "1600000US0643000",
  },
  "kansas-city-mo": {
    description:
      "Kansas City city, Missouri is a city, town, place equivalent, and township located in Missouri. Kansas City city, Missouri has a land area of 314.8 square miles.",
    subtitle: "Place in Missouri",
    lat: 39.0997265,
    lon: -94.5785667,
    title: "Kansas City, MO",
    key: "1600000US2938000",
  },
  "mesa-az": {
    description:
      "Mesa city, Arizona is a city, town, place equivalent, and township located in Arizona. Mesa city, Arizona has a land area of 138.0 square miles.",
    subtitle: "Place in Arizona",
    lat: 33.4151843,
    lon: -111.8314724,
    title: "Mesa, AZ",
    key: "1600000US0446000",
  },
  "virginia-beach-va": {
    description:
      "Virginia Beach city, Virginia is a city, town, place equivalent, and township located in Virginia. Virginia Beach city, Virginia has a land area of 244.7 square miles.",
    subtitle: "Place in Virginia",
    lat: 36.8529263,
    lon: -75.977985,
    title: "Virginia Beach, VA",
    key: "1600000US5182000",
  },
  "atlanta-ga": {
    description:
      "Atlanta city, Georgia is a city, town, place equivalent, and township located in Georgia. Atlanta city, Georgia has a land area of 135.7 square miles.",
    subtitle: "Place in Georgia",
    lat: 33.7489954,
    lon: -84.3879824,
    title: "Atlanta, GA",
    key: "1600000US1304000",
  },
  "colorado-springs-co": {
    description:
      "Colorado Springs city, Colorado is a city, town, place equivalent, and township located in Colorado. Colorado Springs city, Colorado has a land area of 194.9 square miles.",
    subtitle: "Place in Colorado",
    lat: 38.8338816,
    lon: -104.8213634,
    title: "Colorado Springs, CO",
    key: "1600000US0816000",
  },
  "omaha-ne": {
    description:
      "Omaha city, Nebraska is a city, town, place equivalent, and township located in Nebraska. Omaha city, Nebraska has a land area of 140.9 square miles.",
    subtitle: "Place in Nebraska",
    lat: 41.2523634,
    lon: -95.9979883,
    title: "Omaha, NE",
    key: "1600000US3137000",
  },
  "raleigh-nc": {
    description:
      "Raleigh city, North Carolina is a city, town, place equivalent, and township located in North Carolina. Raleigh city, North Carolina has a land area of 145.8 square miles.",
    subtitle: "Place in North Carolina",
    lat: 35.7795897,
    lon: -78.6381787,
    title: "Raleigh, NC",
    key: "1600000US3755000",
  },
  "miami-fl": {
    description:
      "Miami city, Florida is a city, town, place equivalent, and township located in Florida. Miami city, Florida has a land area of 36.0 square miles.",
    subtitle: "Place in Florida",
    lat: 25.7616798,
    lon: -80.1917902,
    title: "Miami, FL",
    key: "1600000US1245000",
  },
  "oakland-ca": {
    description:
      "Oakland city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 37.8043637,
    lon: -122.2711137,
    title: "Oakland, CA",
    key: "1600000US0653000",
  },
  "minneapolis-mn": {
    description:
      "Minneapolis city, Minnesota is a city, town, place equivalent, and township located in Minnesota. Minneapolis city, Minnesota has a land area of 54.0 square miles.",
    subtitle: "Place in Minnesota",
    lat: 44.977753,
    lon: -93.2650108,
    title: "Minneapolis, MN",
    key: "1600000US2743000",
  },
  "tulsa-ok": {
    description:
      "Tulsa city, Oklahoma is a city, town, place equivalent, and township located in Oklahoma. Tulsa city, Oklahoma has a land area of 197.4 square miles.",
    subtitle: "Place in Oklahoma",
    lat: 36.1539816,
    lon: -95.992775,
    title: "Tulsa, OK",
    key: "1600000US4075000",
  },
  "cleveland-oh": {
    description:
      "Cleveland city, Ohio is a city, town, place equivalent, and township located in Ohio. Cleveland city, Ohio has a land area of 77.7 square miles.",
    subtitle: "Place in Ohio",
    lat: 41.49932,
    lon: -81.6943605,
    title: "Cleveland, OH",
    key: "1600000US3916000",
  },
  "wichita-ks": {
    description:
      "Wichita city, Kansas is a city, town, place equivalent, and township located in Kansas. Wichita city, Kansas has a land area of 161.6 square miles.",
    subtitle: "Place in Kansas",
    lat: 37.688889,
    lon: -97.336111,
    title: "Wichita, KS",
    key: "1600000US2079000",
  },
  "arlington-tx": {
    description:
      "Arlington city, Texas is a city, town, place equivalent, and township located in Texas. Arlington city, Texas has a land area of 95.8 square miles.",
    subtitle: "Place in Texas",
    lat: 32.735687,
    lon: -97.1080656,
    title: "Arlington, TX",
    key: "1600000US4804000",
  },
  "new-orleans-la": {
    description:
      "New Orleans city, Louisiana is a city, town, place equivalent, and township located in Louisiana. New Orleans city, Louisiana has a land area of 169.4 square miles.",
    subtitle: "Place in Louisiana",
    lat: 29.9510658,
    lon: -90.0715323,
    title: "New Orleans, LA",
    key: "1600000US2255000",
  },
  "bakersfield-ca": {
    description:
      "Bakersfield city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 35.3732921,
    lon: -119.0187125,
    title: "Bakersfield, CA",
    key: "1600000US0603526",
  },
  "tampa-fl": {
    description:
      "Tampa city, Florida is a city, town, place equivalent, and township located in Florida. Tampa city, Florida has a land area of 114.0 square miles.",
    subtitle: "Place in Florida",
    lat: 27.950575,
    lon: -82.4571776,
    title: "Tampa, FL",
    key: "1600000US1271000",
  },
  "honolulu-hi": {
    description:
      "Urban Honolulu CDP, Hawaii is a city, town, place equivalent, and township located in Hawaii. Urban Honolulu CDP, Hawaii has a land area of 60.5 square miles.",
    subtitle: "Place in Hawaii",
    lat: 21.3069444,
    lon: -157.8583333,
    title: "Honolulu, HI",
    key: "1600000US1571550",
  },
  "aurora-co": {
    description:
      "Aurora city, Colorado is a city, town, place equivalent, and township located in Colorado. Aurora city, Colorado has a land area of 154.2 square miles.",
    subtitle: "Place in Colorado",
    lat: 39.7294319,
    lon: -104.8319195,
    title: "Aurora, CO",
    key: "1600000US0804000",
  },
  "anaheim-ca": {
    description:
      "Anaheim city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 33.8352932,
    lon: -117.9145036,
    title: "Anaheim, CA",
    key: "1600000US0602000",
  },
  "santa-ana-ca": {
    description:
      "Santa Ana city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 33.7455731,
    lon: -117.8678338,
    title: "Santa Ana, CA",
    key: "1600000US0669000",
  },
  "st.-louis-mo": {
    description:
      "St. Louis city, Missouri is a city, town, place equivalent, and township located in Missouri. St. Louis city, Missouri has a land area of 61.7 square miles.",
    subtitle: "Place in Missouri",
    lat: 38.6270025,
    lon: -90.1994042,
    title: "St. Louis, MO",
    key: "1600000US2965000",
  },
  "riverside-ca": {
    description:
      "Riverside city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 33.9533487,
    lon: -117.3961564,
    title: "Riverside, CA",
    key: "1600000US0662000",
  },
  "corpus-christi-tx": {
    description:
      "Corpus Christi city, Texas is a city, town, place equivalent, and township located in Texas. Corpus Christi city, Texas has a land area of 159.7 square miles.",
    subtitle: "Place in Texas",
    lat: 27.8005828,
    lon: -97.396381,
    title: "Corpus Christi, TX",
    key: "1600000US4817000",
  },
  "lexington-fayette-ky": {
    description:
      "Lexington-Fayette urban county, Kentucky is a city, town, place equivalent, and township located in Kentucky. Lexington-Fayette urban county, Kentucky has a land area of 283.6 square miles.",
    subtitle: "Place in Kentucky",
    lat: 38.0405837,
    lon: -84.5037164,
    title: "Lexington-Fayette, KY",
    key: "1600000US2146027",
  },
  "pittsburgh-pa": {
    description:
      "Pittsburgh city, Pennsylvania is a city, town, place equivalent, and township located in Pennsylvania.",
    subtitle: "Place in Pennsylvania",
    lat: 40.4406248,
    lon: -79.9958864,
    title: "Pittsburgh, PA",
    key: "1600000US4261000",
  },
  "anchorage-ak": {
    description:
      "Anchorage municipality, Alaska is a city, town, place equivalent, and township located in Alaska. Anchorage municipality, Alaska has a land area of 1,706.3 square miles.",
    subtitle: "Place in Alaska",
    lat: 61.2180556,
    lon: -149.9002778,
    title: "Anchorage, AK",
    key: "1600000US0203000",
  },
  "stockton-ca": {
    description:
      "Stockton city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 37.9577016,
    lon: -121.2907796,
    title: "Stockton, CA",
    key: "1600000US0675000",
  },
  "cincinnati-oh": {
    description:
      "Cincinnati city, Ohio is a city, town, place equivalent, and township located in Ohio. Cincinnati city, Ohio has a land area of 77.8 square miles.",
    subtitle: "Place in Ohio",
    lat: 39.1031182,
    lon: -84.5120196,
    title: "Cincinnati, OH",
    key: "1600000US3915000",
  },
  "saint-paul-mn": {
    description:
      "St. Paul city, Minnesota is a city, town, place equivalent, and township located in Minnesota. St. Paul city, Minnesota has a land area of 52.0 square miles.",
    subtitle: "Place in Minnesota",
    lat: 44.9537029,
    lon: -93.0899578,
    title: "Saint Paul, MN",
    key: "1600000US2758000",
  },
  "toledo-oh": {
    description:
      "Toledo city, Ohio is a city, town, place equivalent, and township located in Ohio. Toledo city, Ohio has a land area of 80.5 square miles.",
    subtitle: "Place in Ohio",
    lat: 41.6639383,
    lon: -83.555212,
    title: "Toledo, OH",
    key: "1600000US3977000",
  },
  "greensboro-nc": {
    description:
      "Greensboro city, North Carolina is a city, town, place equivalent, and township located in North Carolina. Greensboro city, North Carolina has a land area of 129.0 square miles.",
    subtitle: "Place in North Carolina",
    lat: 36.0726354,
    lon: -79.7919754,
    title: "Greensboro, NC",
    key: "1600000US3728000",
  },
  "newark-nj": {
    description:
      "Newark city, New Jersey is a city, town, place equivalent, and township located in New Jersey. Newark city, New Jersey has a land area of 24.1 square miles.",
    subtitle: "Place in New Jersey",
    lat: 40.735657,
    lon: -74.1723667,
    title: "Newark, NJ",
    key: "1600000US3451000",
  },
  "plano-tx": {
    description:
      "Plano city, Texas is a city, town, place equivalent, and township located in Texas. Plano city, Texas has a land area of 71.7 square miles.",
    subtitle: "Place in Texas",
    lat: 33.0198431,
    lon: -96.6988856,
    title: "Plano, TX",
    key: "1600000US4858016",
  },
  "henderson-nv": {
    description:
      "Henderson city, Nevada is a city, town, place equivalent, and township located in Nevada. Henderson city, Nevada has a land area of 106.1 square miles.",
    subtitle: "Place in Nevada",
    lat: 36.0395247,
    lon: -114.9817213,
    title: "Henderson, NV",
    key: "1600000US3231900",
  },
  "lincoln-ne": {
    description:
      "Lincoln city, Nebraska is a city, town, place equivalent, and township located in Nebraska. Lincoln city, Nebraska has a land area of 96.2 square miles.",
    subtitle: "Place in Nebraska",
    lat: 40.8257625,
    lon: -96.6851982,
    title: "Lincoln, NE",
    key: "1600000US3128000",
  },
  "buffalo-ny": {
    description:
      "Buffalo city, New York is a city, town, place equivalent, and township located in New York. Buffalo city, New York has a land area of 40.4 square miles.",
    subtitle: "Place in New York",
    lat: 42.8864468,
    lon: -78.8783689,
    title: "Buffalo, NY",
    key: "1600000US3611000",
  },
  "jersey-city-nj": {
    description:
      "Jersey City city, New Jersey is a city, town, place equivalent, and township located in New Jersey. Jersey City city, New Jersey has a land area of 14.7 square miles.",
    subtitle: "Place in New Jersey",
    lat: 40.7281575,
    lon: -74.0776417,
    title: "Jersey City, NJ",
    key: "1600000US3436000",
  },
  "chula-vista-ca": {
    description:
      "Chula Vista city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 32.6400541,
    lon: -117.0841955,
    title: "Chula Vista, CA",
    key: "1600000US0613392",
  },
  "fort-wayne-in": {
    description:
      "Fort Wayne city, Indiana is a city, town, place equivalent, and township located in Indiana. Fort Wayne city, Indiana has a land area of 110.6 square miles.",
    subtitle: "Place in Indiana",
    lat: 41.079273,
    lon: -85.1393513,
    title: "Fort Wayne, IN",
    key: "1600000US1825000",
  },
  "orlando-fl": {
    description:
      "Orlando city, Florida is a city, town, place equivalent, and township located in Florida. Orlando city, Florida has a land area of 110.5 square miles.",
    subtitle: "Place in Florida",
    lat: 28.5383355,
    lon: -81.3792365,
    title: "Orlando, FL",
    key: "1600000US1253000",
  },
  "st.-petersburg-fl": {
    description:
      "St. Petersburg city, Florida is a city, town, place equivalent, and township located in Florida. St. Petersburg city, Florida has a land area of 61.8 square miles.",
    subtitle: "Place in Florida",
    lat: 27.773056,
    lon: -82.64,
    title: "St. Petersburg, FL",
    key: "1600000US1263000",
  },
  "chandler-az": {
    description:
      "Chandler city, Arizona is a city, town, place equivalent, and township located in Arizona. Chandler city, Arizona has a land area of 65.1 square miles.",
    subtitle: "Place in Arizona",
    lat: 33.3061605,
    lon: -111.8412502,
    title: "Chandler, AZ",
    key: "1600000US0412000",
  },
  "laredo-tx": {
    description:
      "Laredo Ranchettes CDP, Texas is a city, town, place equivalent, and township located in Texas. Laredo Ranchettes CDP, Texas has a land area of 0.6 square miles.",
    subtitle: "Place in Texas",
    lat: 27.5305671,
    lon: -99.4803241,
    title: "Laredo, TX",
    key: "1600000US4841473",
  },
  "norfolk-va": {
    description:
      "Norfolk city, Virginia is a city, town, place equivalent, and township located in Virginia. Norfolk city, Virginia has a land area of 53.3 square miles.",
    subtitle: "Place in Virginia",
    lat: 36.8507689,
    lon: -76.2858726,
    title: "Norfolk, VA",
    key: "1600000US5157000",
  },
  "durham-nc": {
    description:
      "Durham city, North Carolina is a city, town, place equivalent, and township located in North Carolina. Durham city, North Carolina has a land area of 112.2 square miles.",
    subtitle: "Place in North Carolina",
    lat: 35.9940329,
    lon: -78.898619,
    title: "Durham, NC",
    key: "1600000US3719000",
  },
  "madison-wi": {
    description:
      "Madison city, Wisconsin is a city, town, place equivalent, and township located in Wisconsin. Madison city, Wisconsin has a land area of 79.3 square miles.",
    subtitle: "Place in Wisconsin",
    lat: 43.0730517,
    lon: -89.4012302,
    title: "Madison, WI",
    key: "1600000US5548000",
  },
  "lubbock-tx": {
    description:
      "Lubbock city, Texas is a city, town, place equivalent, and township located in Texas. Lubbock city, Texas has a land area of 134.7 square miles.",
    subtitle: "Place in Texas",
    lat: 33.5778631,
    lon: -101.8551665,
    title: "Lubbock, TX",
    key: "1600000US4845000",
  },
  "irvine-ca": {
    description:
      "Irvine city, California is a city, town, place equivalent, and township located in California. Irvine city, California has a land area of 65.6 square miles.",
    subtitle: "Place in California",
    lat: 33.6839473,
    lon: -117.7946942,
    title: "Irvine, CA",
    key: "1600000US0636770",
  },
  "winston-salem-nc": {
    description:
      "Winston-Salem city, North Carolina is a city, town, place equivalent, and township located in North Carolina. Winston-Salem city, North Carolina has a land area of 132.6 square miles.",
    subtitle: "Place in North Carolina",
    lat: 36.0998596,
    lon: -80.244216,
    title: "Winston-Salem, NC",
    key: "1600000US3775000",
  },
  "glendale-az": {
    description:
      "Glendale city, Arizona is a city, town, place equivalent, and township located in Arizona. Glendale city, Arizona has a land area of 61.6 square miles.",
    subtitle: "Place in Arizona",
    lat: 33.5386523,
    lon: -112.1859866,
    title: "Glendale, AZ",
    key: "1600000US0427820",
  },
  "garland-tx": {
    description:
      "Garland city, Texas is a city, town, place equivalent, and township located in Texas. Garland city, Texas has a land area of 57.0 square miles.",
    subtitle: "Place in Texas",
    lat: 32.912624,
    lon: -96.6388833,
    title: "Garland, TX",
    key: "1600000US4829000",
  },
  "hialeah-fl": {
    description:
      "Hialeah Gardens city, Florida is a city, town, place equivalent, and township located in Florida. Hialeah Gardens city, Florida has a land area of 3.2 square miles.",
    subtitle: "Place in Florida",
    lat: 25.8575963,
    lon: -80.2781057,
    title: "Hialeah, FL",
    key: "1600000US1230025",
  },
  "reno-nv": {
    description:
      "Reno city, Nevada is a city, town, place equivalent, and township located in Nevada. Reno city, Nevada has a land area of 108.7 square miles.",
    subtitle: "Place in Nevada",
    lat: 39.5296329,
    lon: -119.8138027,
    title: "Reno, NV",
    key: "1600000US3260600",
  },
  "chesapeake-va": {
    description:
      "Chesapeake city, Virginia is a city, town, place equivalent, and township located in Virginia. Chesapeake city, Virginia has a land area of 338.4 square miles.",
    subtitle: "Place in Virginia",
    lat: 36.7682088,
    lon: -76.2874927,
    title: "Chesapeake, VA",
    key: "1600000US5116000",
  },
  "gilbert-az": {
    description:
      "Gilbert town, Arizona is a city, town, place equivalent, and township located in Arizona. Gilbert town, Arizona has a land area of 68.5 square miles.",
    subtitle: "Place in Arizona",
    lat: 33.3528264,
    lon: -111.789027,
    title: "Gilbert, AZ",
    key: "1600000US0427400",
  },
  "baton-rouge-la": {
    description:
      "Baton Rouge city, Louisiana is a city, town, place equivalent, and township located in Louisiana. Baton Rouge city, Louisiana has a land area of 86.4 square miles.",
    subtitle: "Place in Louisiana",
    lat: 30.4582829,
    lon: -91.1403196,
    title: "Baton Rouge, LA",
    key: "1600000US2205000",
  },
  "irving-tx": {
    description:
      "Irving city, Texas is a city, town, place equivalent, and township located in Texas. Irving city, Texas has a land area of 67.0 square miles.",
    subtitle: "Place in Texas",
    lat: 32.8140177,
    lon: -96.9488945,
    title: "Irving, TX",
    key: "1600000US4837000",
  },
  "scottsdale-az": {
    description:
      "Scottsdale city, Arizona is a city, town, place equivalent, and township located in Arizona. Scottsdale city, Arizona has a land area of 183.9 square miles.",
    subtitle: "Place in Arizona",
    lat: 33.4941704,
    lon: -111.9260519,
    title: "Scottsdale, AZ",
    key: "1600000US0465000",
  },
  "north-las-vegas-nv": {
    description:
      "North Las Vegas city, Nevada is a city, town, place equivalent, and township located in Nevada. North Las Vegas city, Nevada has a land area of 98.0 square miles.",
    subtitle: "Place in Nevada",
    lat: 36.1988592,
    lon: -115.1175013,
    title: "North Las Vegas, NV",
    key: "1600000US3251800",
  },
  "fremont-ca": {
    description:
      "Fremont city, California is a city, town, place equivalent, and township located in California. Fremont city, California has a land area of 77.4 square miles.",
    subtitle: "Place in California",
    lat: 37.5482697,
    lon: -121.9885719,
    title: "Fremont, CA",
    key: "1600000US0626000",
  },
  "boise-id": {
    description:
      "Boise City city, Idaho is a city, town, place equivalent, and township located in Idaho. Boise City city, Idaho has a land area of 83.7 square miles.",
    subtitle: "Place in Idaho",
    lat: 43.6187102,
    lon: -116.2146068,
    title: "Boise, ID",
    key: "1600000US1608830",
  },
  "richmond-va": {
    description:
      "Richmond city, Virginia is a city, town, place equivalent, and township located in Virginia. Richmond city, Virginia has a land area of 59.9 square miles.",
    subtitle: "Place in Virginia",
    lat: 37.5407246,
    lon: -77.4360481,
    title: "Richmond, VA",
    key: "1600000US5167000",
  },
  "san-bernardino-ca": {
    description:
      "San Bernardino city, California is a city, town, place equivalent, and township located in California.",
    subtitle: "Place in California",
    lat: 34.1083449,
    lon: -117.2897652,
    title: "San Bernardino, CA",
    key: "1600000US0665000",
  },
};

export const cityRefArr = Object.keys(cityRef).map((x) => ({
  path: x,
  ...cityRef[x as keyof typeof cityRef],
}));
